// extracted by mini-css-extract-plugin
export default {"Body":"DialogBox_Body__qblkQ","Footer":"DialogBox_Footer__HKmJt"};